
import { Button } from "@mui/material"; // Importa el componente Button de la librería Material UI
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'; // Importa un ícono de flecha hacia atrás de la librería de íconos de Material UI
import { useNavigate } from "react-router-dom"; // Importa el hook 'useNavigate' de react-router-dom para navegar entre rutas

export default function BioChemical(){ // Define el componente funcional BioChemical
  const navigate = useNavigate(); // Inicializa el hook de navegación para poder redirigir a otras rutas

  // Define los estilos para el contenedor donde se incrustará el video
  const containerStyles = {
    height: '485px', // Establece la altura del contenedor
    left: '406px', // Define la posición horizontal del contenedor
    position: 'absolute', // Establece la posición como absoluta
    top: '189px', // Define la posición vertical del contenedor
    width: '662px', // Define el ancho del contenedor
    zIndex: 100, // Establece el índice Z para el apilamiento de los elementos
  };

  // Define los estilos para el iframe que contiene el video
  const iframeStyles = {
    borderWidth: '0px', // Elimina el borde del iframe
    height: '100%', // Define la altura del iframe al 100% del contenedor
    position: 'absolute', // Establece la posición como absoluta
    width: '100%', // Define el ancho del iframe al 100% del contenedor
  };

  return (
    <>
      <Button onClick={() => navigate("/sonidos")}> {/* Botón que redirige a la página principal (ruta "/") al hacer clic */}
        <ArrowBackIosNewOutlinedIcon/> {/* Muestra el ícono de flecha hacia atrás dentro del botón */}
      </Button>
      <div
        id="bzl-noise.head.166177466649" // Asigna un ID único al contenedor
        className="webvideo resizable object" // Aplica clases CSS para estilo
        style={containerStyles} // Aplica los estilos definidos para el contenedor
      >
        <iframe
          src="//player.vimeo.com/video/520670440?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff" // URL del video de Vimeo con parámetros para ocultar el título, el autor y la imagen del perfil
          style={iframeStyles} // Aplica los estilos definidos para el iframe
          title="Bzl Noise Video" // Título del iframe
          frameBorder="0" // Elimina el borde del iframe
          allow="autoplay; fullscreen" // Permite la reproducción automática y la opción de pantalla completa
        />
      </div>    
    </>
  )
}


